export const controlTelemetry = {
  theme: 'Text',
  boxMode: 'RoundCorners',
  border: 'solid 1px #ccc',
  textColor: '#e4002b',
  backColor: 'inherit',
  fontSize: '0.65em',
  fontWeight: '700'
};
